import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import Popup from '../../components/popup';


const InitiatePaymentCreate = ()=>{
     const [msisdn, setMsisdn ] = useState('');
     const [amount, setAmount ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const[paymentType, setPaymentType] = useState("stk_push");
     const[showMsisdn,setShowMsisdn] = useState(true);
     const[responseCode,setResponseCode] = useState('');
     const[qrCode, setQrCode] = useState('');
     const [showPopup, setShowPopup] = useState(false);
     const [errorMessage, setErrorMessage] = useState('');
     const[loading, setLoading] = useState(false);
     const [hasError,setHasError] = useState(false);

     const submit = async (e)=>{
         e.preventDefault();
         setLoading(true);

         try {
            const {data} = await axios.post('initiatePayment', {
                msisdn,
                amount,
                payment_type:paymentType
            });
            //console.log(data);
            setQrCode(data.QRCode);
            setResponseCode(data.ResponseCode);
            if(data.ResponseCode=== "00"){
                setShowPopup(true);
            }
            setHasError(false);
         } catch (error) {
            console.log(error.code);
            setHasError(true);
            if(error.code ==="ERR_NETWORK"){
                setErrorMessage("Unable to connect to " + paymentType + " Server. Try again");
            }
         }
         finally{
            setLoading(false);
         }

         if(paymentType === "mpesa_qr"){
            setRedirect(false);
         }else{
            setRedirect(true);
         }
         
        
     }

     const actionPaymentType = (e)=>{
        // console.log(e);
         if(e==="mpesa_qr"){
             setShowMsisdn(false);
           
         }else{
            setShowMsisdn(true);
         }
         setPaymentType(e);
     }
    if(redirect){
        return <Navigate to={'/initiatePayment'} />
    }

    const handleClosePopup = () => {
        setShowPopup(false);
      };
     return (
         <Wrapper pageTitle={"New InitiatePayment"}>
            <InnerNav createLink={'/initiatePaymentCreate'} listLink={'/initiatePayment'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Payment Type</span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        
                        onChange = {e => actionPaymentType(e.target.value)} >
                           <option value="0">Choose Payment Type</option> 
                           <option value="ussd_push">USSD Push</option>
                           <option value="mpesa_qr">MPESA APP QR CODE</option>
                           <option value="custom_qr">CUSTOM QR CODE</option>
                           <option value="OCr">VEHICLE OCR</option>
                            </select>
                    </label>
                    {showMsisdn &&
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn"
                        onChange = {e => setMsisdn(e.target.value)} />
                    </label>
                    }

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        disabled={loading}
                        > 
                       {loading ? 'Loading...' : (
                            <>
                                <FiSave />
                                <span className="ml-3">Save</span>
                            </>
                            )}

                         </button>
                        </label>
                        <div className="mx-3">
                            {hasError&&
                            (
                            <div className="bg-red-500 text-white leading-5 text-center mt-4 text-sm  px-4 py-2">
                                {errorMessage}
                            </div>
                            )
                            }
                        </div>
                    </div>
                </div>
             </form>

             {showPopup && <Popup qrCode={qrCode} onClose={handleClosePopup} />}
        </Wrapper>
     );
};
export default InitiatePaymentCreate;